import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-recursive-check-box',
  templateUrl: './recursive-check-box.component.html',
  styleUrls: ['./recursive-check-box.component.scss'],
})
export class RecursiveCheckBoxComponent implements OnInit {
  @Input() Datos = []
  @Output() newVal = new EventEmitter()
  @Output() valoresNetos = new EventEmitter()

  constructor() { }

  ngOnInit() {
    for (let i in this.Datos) {
      let cant = 0
      for (let b of this.Datos[i].subTasks) {
        if (b.Check || b.Indeterminado == true) {
          cant += 1
        }
      }

      if (cant > 0 && cant < this.Datos[i].subTasks.length) {
        this.Datos[i].Indeterminado = true
      } else {
        this.Datos[i].Indeterminado = false
      }

      this.Valorar(i)
    }


  }


  Indeterminado(i) {
    let cant = 0
    for (let b of this.Datos[i].subTasks) {
      if (b.Check || b.Indeterminado == true) {
        cant += 1
      }
    }

    if (cant > 0 && cant < this.Datos[i].subTasks.length) {
      this.Datos[i].Indeterminado = true
    } else {
      this.Datos[i].Indeterminado = false
    }
  }

  Checkado(indice) {
    let cant = 0
    for (let i of this.Datos[indice].subTasks) {
      if (i.Check) {
        cant += 1
      }
    }

    if (cant == this.Datos[indice].subTasks.length) {
      this.Datos[indice].Check = true
    } else {
      this.Datos[indice].Check = false

    }
  }

  Valorar(indice) {
    if (this.Datos[indice].subTasks.length > 0) {
      this.Datos[indice].Valor = []
      for (let i of this.Datos[indice].subTasks) {
        if (i.Check) {
          this.Datos[indice].Valor = this.Datos[indice].Valor.concat(i.Valor)
        }
      }
    }
  }

  CambiarSeleccion(data) {
    setTimeout(() => {
      for (let i in data.subTasks) {
        data.subTasks[i].Check = data.Check
      }
      this.newVal.emit(this.Datos)
    }, 50);
  }

  RecibirNewVal(indiceO, emicion) {
    this.Datos[indiceO].subTasks = emicion
    setTimeout(() => {
      this.Indeterminado(indiceO)
      this.Checkado(indiceO)
      this.Valorar(indiceO)
      this.newVal.emit(this.Datos)
    }, 1);
  }

}
